import { AbstractDownloadableService } from "../abstract-downloadable.service";
import { AbstractReport } from '../../models/reports/abstract-report.model';

/**
 * @class AbstractReportPmsApiService
 * @abstract
 * @extends {AbstractDownloadableService<Feedback>}
 */
export class AbstractReportPmsApiService extends AbstractDownloadableService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/report';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {AbstractReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new AbstractReport(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Feedback>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    exportPdf(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/export-pdf';

        return this.download(url, params, 'Report.pdf');
    }

    exportCsv(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/export-csv';

        return this.download(url, params, 'Report.csv');
    }

    exportExcel(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/export-excel';

        return this.download(url, params, 'Report.xlsx');
    }

    emailPdf(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0}) + '/email-pdf';

        return this.http
            .post(url, params, {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/abstract-report.service.js